import React from 'react';

export function Home(){
  return (
    <div>
      <h1>In-Home Massage</h1>
      <h1>Theraputics</h1>
      <p>RELAX.....REJUVINATE.....REPEAT.......</p>
      <p>The benefits of massage therapy are HUGE!</p>
      <p>From tension or trigger points to sprains or anxiety, there is a therapy for you.</p> 
      <p>Find the right therapy for your needs.</p>   
    </div>
);
}